import colors from '@constants/colors';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface SkeletonProps {
    width?: string | number;
    height?: string | number;
    radius?: string | number;
    className?: string;
    style?: React.CSSProperties;
    children?: ReactNode;
}

function Skeleton({
    width = '100%', height = 20, radius = 4, className, style, children,
}: SkeletonProps) {
    return (
        <Base
            className={className}
            style={style}
            width={width}
            height={height}
            radius={radius}>
            {children}
        </Base>
    );
}

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
`;

const Base = styled.div<{
    width: string | number;
    height: string | number;
    radius: string| number }>`
    width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
    min-width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    min-height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
    border-radius: ${({ radius }) => (typeof radius === 'string' ? radius : `${radius}px`)};
    background-color: ${colors.gray2}; 
    animation: ${pulse} 1.5s ease-in-out infinite;
    position: relative;
`;

export { default as SkeletonBlank } from './SkeletonBlank';

export default Skeleton;
